import React, { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./StudentPreInterviewsUIHelpers";

const StudentPreInterviewsUIContext = createContext();

export function useStudentPreInterviewsUIContext() {
  return useContext(StudentPreInterviewsUIContext);
}

export const StudentPreInterviewsUIConsumer = StudentPreInterviewsUIContext.Consumer;

export function StudentPreInterviewsUIProvider({ preInterviewsUIEvents, children }) {
  const { user } = useSelector(state => state.auth);
  initialFilter.term = user.currentActiveTerm; // Mevcut Aktif Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewStudentPreInterviewPage: preInterviewsUIEvents.openNewStudentPreInterviewPage,
    openEditStudentPreInterviewPage: preInterviewsUIEvents.openEditStudentPreInterviewPage,
    openFinalRegistrationPage: preInterviewsUIEvents.openFinalRegistrationPage
  };

  return (
    <StudentPreInterviewsUIContext.Provider value={value}>
      {children}
    </StudentPreInterviewsUIContext.Provider>
  );
}